
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";

interface RestaurantDetailsProps {
  mealPriceRange: string;
  setMealPriceRange: (value: string) => void;
  cuisineType: string;
  setCuisineType: (value: string) => void;
  cuisineSpecialties: string;
  setCuisineSpecialties: (value: string) => void;
  dressCode: string;
  setDressCode: (value: string) => void;
  outdoorSeating: boolean;
  setOutdoorSeating: (value: boolean) => void;
  isExistingPlace?: boolean;
}

export function RestaurantDetails({
  mealPriceRange,
  setMealPriceRange,
  cuisineType,
  setCuisineType,
  cuisineSpecialties,
  setCuisineSpecialties,
  dressCode,
  setDressCode,
  outdoorSeating,
  setOutdoorSeating,
  isExistingPlace = false
}: RestaurantDetailsProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Meal Price Range ($)</Label>
        <Input
          type="number"
          value={mealPriceRange}
          onChange={(e) => setMealPriceRange(e.target.value)}
          placeholder="Average meal cost"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>
      
      <div className="space-y-2">
        <Label>Cuisine Type</Label>
        <Input
          value={cuisineType}
          onChange={(e) => setCuisineType(e.target.value)}
          placeholder="E.g., Italian, Japanese, etc."
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>
      
      <div className="space-y-2">
        <Label>Cuisine Specialties</Label>
        <Input
          value={cuisineSpecialties}
          onChange={(e) => setCuisineSpecialties(e.target.value)}
          placeholder="Enter specialties separated by commas"
          className={isExistingPlace ? "bg-gray-50" : ""}
          readOnly={isExistingPlace}
        />
      </div>

      <div className="space-y-2">
        <Label>Dress Code</Label>
        <Select 
          value={dressCode} 
          onValueChange={setDressCode}
          disabled={isExistingPlace}
        >
          <SelectTrigger className={isExistingPlace ? "bg-gray-50" : ""}>
            <SelectValue placeholder="Select dress code" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="casual">Casual</SelectItem>
            <SelectItem value="smart_casual">Smart Casual</SelectItem>
            <SelectItem value="business_casual">Business Casual</SelectItem>
            <SelectItem value="formal">Formal</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center space-x-2">
        <Switch
          checked={outdoorSeating}
          onCheckedChange={setOutdoorSeating}
          disabled={isExistingPlace}
        />
        <Label className={isExistingPlace ? "text-muted-foreground" : ""}>
          Outdoor Seating Available
        </Label>
      </div>
    </div>
  );
}
